export const isUnifiedPositionEnabled = (): boolean => {
    // temporary hardcoded FF value
    return false;
};
